import script from "./FingerPrintRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./FingerPrintRegister.vue?vue&type=script&setup=true&lang=js"

import "./FingerPrintRegister.vue?vue&type=style&index=0&id=13595834&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13595834"]])

export default __exports__